import React from 'react';
import { Box, Typography, IconButton } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';
import { useCart } from '../../context/CartContext';

export default function CartItem({ item, compact = false }) {
  const { updateQuantity, removeItem, cartKey } = useCart();
  const key = cartKey(item);
  const effectivePrice = Number(item.Price) + Number(item.PriceAdjustment || 0);

  return (
    <Box sx={{ display: 'flex', gap: 2, py: 1.5, borderBottom: '1px solid #eee' }}>
      <Box
        component="img"
        src={item.ImageUrl || 'https://via.placeholder.com/80x80?text=No+Image'}
        alt={item.Name}
        sx={{ width: compact ? 60 : 80, height: compact ? 60 : 80, objectFit: 'cover', borderRadius: 1 }}
      />
      <Box sx={{ flex: 1, minWidth: 0 }}>
        <Typography variant="body2" sx={{ fontWeight: 600, mb: 0.25, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
          {item.Name}
        </Typography>
        {(item.Size || item.Color) && (
          <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mb: 0.25 }}>
            {[item.Size && `Size: ${item.Size}`, item.Color && `Color: ${item.Color}`].filter(Boolean).join(' | ')}
          </Typography>
        )}
        <Typography variant="body2" color="text.secondary">${effectivePrice.toFixed(2)}</Typography>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mt: 0.5 }}>
          <IconButton size="small" onClick={() => updateQuantity(key, item.quantity - 1)}>
            <RemoveIcon fontSize="small" />
          </IconButton>
          <Typography variant="body2" sx={{ fontWeight: 600, minWidth: 20, textAlign: 'center' }}>
            {item.quantity}
          </Typography>
          <IconButton size="small" onClick={() => updateQuantity(key, item.quantity + 1)}>
            <AddIcon fontSize="small" />
          </IconButton>
          <IconButton size="small" onClick={() => removeItem(key)} sx={{ ml: 'auto' }}>
            <DeleteIcon fontSize="small" color="error" />
          </IconButton>
        </Box>
      </Box>
      <Typography variant="body2" sx={{ fontWeight: 700, whiteSpace: 'nowrap' }}>
        ${(effectivePrice * item.quantity).toFixed(2)}
      </Typography>
    </Box>
  );
}
